import AlfabetizacaoSeminario from 'models/alfabetizacao/AlfabetizacaoSeminario';
import { GenericService } from '../Generic.service';

export default class AlfabetizacaoSeminarioService extends GenericService {
    readonly URI: string = '/v1/seminario360';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    public validation(cpf: string) {
        if (cpf) return this.get('validar', { cpf });
    }

    public create(form: AlfabetizacaoSeminario) {
        return this.post('', form);
    }
}
